<template>
  <section>
    <v-row class="my-5" v-if="Object.keys(ticketsList).length > 0">
      <v-col cols="12">
        <v-expand-transition>
          <section>
            <h3 class="mt-4 mb-2">
              {{ $translate('CHOOSE_AN_OPTION') }}
            </h3>

            <v-row class="mb-3">
              <v-col
                v-for="(item, index) in ticketsList"
                cols="12"
                md="8"
                :key="index"
              >
                <v-card elevation="2">
                  <v-row class="ma-0">
                    <v-col cols="9">
                      <h4>{{ item.Name }}</h4>
                      <div v-if="item.Price != null" class="text-subtitle-1">
                        {{ $translate('UNIT_PRICE') }}:
                        {{ formatter.format(getTicketUnitPrice(item)) }}
                        <span class="text-caption text--secondary">{{
                          getPriceSuffix()
                        }}</span>
                      </div>
                      <div v-if="isProfUser">
                        <span class="text-body-2">
                          {{ formatter.format(item.Price) }}
                        </span>
                        <span class="text-caption text--secondary">
                          {{ getVATText(item.VatPercentage) }}
                        </span>
                      </div>
                      <div
                        class="hidden-sm-and-down text-body-2 text--secondary mt-2"
                      >
                        {{ item.Description }}
                      </div>
                    </v-col>

                    <v-col cols="3" align="end">
                      <v-row justify="start" justify-md="end">
                        <v-btn-toggle group>
                          <v-btn
                            large
                            @click="
                              item.Amount === item.MinAmount
                                ? (item.Amount = item.MinAmount)
                                : item.Amount--
                            "
                            icon
                            color="primary"
                          >
                            <v-icon>remove_circle</v-icon>
                          </v-btn>
                          <h3 class="ticketAmount">{{ item.Amount }}</h3>
                          <v-btn
                            large
                            @click="
                              item.Amount === item.MaxAmount
                                ? (item.Amount = item.MaxAmount)
                                : item.Amount++
                            "
                            icon
                            color="primary"
                          >
                            <v-icon>add_circle</v-icon>
                          </v-btn>
                        </v-btn-toggle>
                      </v-row>
                    </v-col>
                    <v-col class="hidden-md-and-up" cols="12">
                      <p class="ma-0">{{ item.Description }}</p>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </section>
        </v-expand-transition>
      </v-col>
    </v-row>
  </section>
</template>

<script>
// import doRequest from '@/api/dssRequest';
import { getVATText } from '@/objects/Product';

export default {
  name: 'DeliveryPickUpTickets',
  props: {
    ticketsList: Object,
    isProfUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formatter: new Intl.NumberFormat('nl', {
        style: 'currency',
        currency: 'EUR',
      }),
    };
  },
  computed: {},
  methods: {
    getTicketUnitPrice(ticket) {
      if (this.isProfUser) {
        return ticket.Price - ticket.VatPrice;
      }
      return ticket.Price;
    },
    getPriceSuffix() {
      if (this.isProfUser) {
        return this.$translate('EXCL_VAT');
      }
      return '';
    },
    getVATText,
  },
};
</script>
